module.exports = __webpack_public_path__ + "img/no_data_found.1604d379.png";